import configs from '../../globals/configs';

export default (input, list) => {
	const hasNotMinSymbolsLength = input.length < configs.search.minInputLength;
	const isListEmpty = list === null;
	if (hasNotMinSymbolsLength || isListEmpty) {
		return null;
	}

	const results = list.filter(({ text }) =>
		text.toLowerCase().includes(input.toLowerCase())
	);

	const hasNoResults = results.length === 0;
	if (hasNoResults) {
		return null;
	}

	return results;
};
